import React from 'react';

import { IdSearchItemProps } from './IdSearchItem.props';
import { StyledStack } from './IdSearchItem.styles';
import { COLORS } from '../../../configs/colors';
import { Typography, TypographyVariantProps } from '../../atoms/Typography';

export const IdSearchItem: React.FC<IdSearchItemProps> = ({
  data
}) => {
  return (
    <StyledStack direction="column">
      <Typography textColor={COLORS.Black} variant={TypographyVariantProps.Caption}>{data.id}</Typography>
    </StyledStack>
  );
};
